export default __webpack_public_path__ + "static/media/fig56.d0daf273.png";